<template>
  <div>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <div class="level">
      <div class="level-left">
        <h4 class="title is-4">{{createOrUpdate}}</h4>
      </div>
      <div class="level-right">
        <button :class="buttonSave" @click="saveInfo()">Save</button>&nbsp;
        <router-link class="button is-small" :to="{name: 'List of Pull Out to Client'}">Go back to list</router-link>
      </div>
    </div>
    <hr/>
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Ticket ID</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="pullOutToClientIdPreview" disabled />
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label is-small">Clients</label>
          <div class="control">
            <b-autocomplete v-model="clientName" size="is-small" :data="clients" placeholder="Search clients" @select="option => selectedClient = option" @input="searchClients" v-validate="'required'" name="Client" :loading="isFetchingClients">
              <template slot="empty">
                <span v-if="isFetchingClients">
                  Please wait...
                </span>
                <span v-if="clients.length === 0">
                  No results found
                </span>
              </template>
            </b-autocomplete>
            <span style="font-size:12px" class="has-text-danger">{{ errors.first('Client') }}</span>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Address</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="pullOutToClient.address" />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Contact person</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="pullOutToClient.contactPerson" />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Email</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="pullOutToClient.email" v-validate="'email'" name="Email" />
            <span style="font-size:12px" class="has-text-danger">{{ errors.first('Email') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Contact #</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="pullOutToClient.phone" />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Designation</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="pullOutToClient.designation" />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Date</label>
          <div class="control">
            <input type="date" class="input is-small" v-model="pullOutToClient.date" />
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="columns">
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">QTY</label>
          <div class="control">
            <input type="number" class="input is-small" v-model="pullOutToClientForTable.quantity" />
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Item</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="pullOutToClientForTable.item" />
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Serial #</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="pullOutToClientForTable.serialNumber" />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Date purchase</label>
          <div class="control">
            <input type="date" class="input is-small" v-model="pullOutToClientForTable.datePurchase" />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">End of warranty</label>
          <div class="control">
            <input type="date" class="input is-small" v-model="pullOutToClientForTable.endOfWarrantyDate" />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Problem</label>
          <div class="control">
            <textarea class="input is-small" v-model="pullOutToClientForTable.problem" />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Remarks</label>
          <div class="control">
            <textarea class="input is-small" v-model="pullOutToClientForTable.remarks" />
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left">

      </div>
      <div class="level-left">
        <button class="button is-info is-small" @click="addOrEditTopullOutToClientDetails">{{addOrEditToTable}}</button>
        <span v-show="addOrEditToTable === 'Update'">
          &nbsp;
          <button class="button is-small" @click="cancelSelected">Cancel</button>
        </span>
      </div>
    </div>
    <b-table :data="pullOutToClient.pullOutToClientDetails" :loading="isLoadingTable">
      <template slot-scope="item">
        <b-table-column class="table-column-content-is-small" label="QTY">
          {{item.row.quantity}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Item">
          {{item.row.item}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Serial #">
          {{item.row.serialNumber}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Date purchase">
          {{item.row.datePurchase}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="End of warranty">
          {{item.row.endOfWarrantyDate}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Problem">
          {{item.row.problem}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Remarks">
          {{item.row.remarks}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <button class="button is-warning is-small" @click="selectForEdit(item.row)">Edit</button>
          &nbsp;
          <button :class="buttonDelete" @click="removeFromTable(item.row.pullOutToClientDetailId ? item.row.pullOutToClientDetailId : item.row.tempId)">Delete</button>
        </b-table-column>
      </template>
    </b-table>
    <hr />
    <div class="level">
      <div class="level-left">

      </div>
      <div class="level-right">
        <button :class="buttonSave" @click="saveInfo()">Save</button>&nbsp;
        <router-link class="button is-small" :to="{name: 'List of Pull Out to Client'}">Go back to list</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'
import moment from 'moment'
import AuthService from '../../_services/auth'

const appToast = new AppToast()
const appButton = new AppButton()
const authService = new AuthService()

export default {
  data: () => ({
    createOrUpdate: 'Create',
    isLoadingTable: false,
    isLoading: false,
    isFullPage: true,
    pullOutToClientIdPreview: 'AUTO GENERATED',
    pullOutToClient: {
      pullOutToClientId: 0,
      pullOutToClientDetails: []
    },
    pullOutToClientForTable: {},
    addOrEditToTable: 'Add',
    clientInfo: {},
    // buttons
    buttonSave: appButton.isLoadingSuccess(false),
    buttonDelete: appButton.isLoadingDanger(false),
    // search clients
    clientName: '',
    clients: [],
    selectedClient: 0,
    isFetchingClients: false
  }),
  created() {
    const pullOutToClientId = this.$route.params.pullOutToClientId
    if (pullOutToClientId) {
      this.getById(pullOutToClientId)
    } else {
      // Create mode
      this.getCurrentDateFromServer()
    }
  },
  methods: {
    getCurrentDateFromServer() {
      this.isLoading = true
      axios
        .get(`api/settings/current-date`)
        .then(response => {
          this.pullOutToClient.date = moment(response.data).format('YYYY-MM-DD')
        })
        .catch(error => console.log(error))
        .then(() => {
          this.isLoading = false
        })
    },
    getById(id) {
      if (id) {
        this.createOrUpdate = '...'
        this.isLoading = true
        axios
          .get(`api/pullouttoclients/${id}`)
          .then(response => {
            response.data.pullOutToClientDetails.forEach(data => {
              data.datePurchase = moment(data.datePurchase).format('YYYY-MM-DD')
              data.endOfWarrantyDate = moment(data.endOfWarrantyDate).format(
                'YYYY-MM-DD'
              )
            })
            this.pullOutToClient = response.data
            this.pullOutToClient.date = moment(
              this.pullOutToClient.date
            ).format('YYYY-MM-DD')
            this.clientName = this.pullOutToClient.client
            this.createOrUpdate = 'Edit'
            this.pullOutToClientIdPreview = this.pullOutToClient.pullOutToClientId
          })
          .catch(error =>
            appToast.danger(
              `Something went wrong. Failed to get the data: ${error}`
            )
          )
          .then(() => {
            this.isLoading = false
          })
      }
    },
    saveInfo() {
      if (!this.pullOutToClient.date) {
        appToast.warning('Pull out to client date must is required')
        return false
      }

      if (this.pullOutToClient.pullOutToClientDetails.length === 0) {
        appToast.warning(
          'Pull out to client detail table is empty. Please add at least one row'
        )
        return false
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          this.buttonSave = appButton.isLoadingSuccess(true)
          this.pullOutToClient.id = 0 // user id
          if (this.pullOutToClient.pullOutToClientId == 0) {
            // CREATE
            axios
              .post(`api/pullouttoclients`, this.pullOutToClient)
              .then(response => {
                appToast.success(response.data)
                this.$router.push({ name: 'List of Pull Out to Client' })
              })
              .catch(error => appToast.danger(error.response.data))
              .then(() => {
                this.buttonSave = appButton.isLoadingSuccess(false)
              })
          } else {
            // UPDATE
            const pullOutToClientId = this.pullOutToClient.pullOutToClientId
            // delete existing list
            axios
              .delete(
                `api/pullouttoclients/delete-pull-out-client/${pullOutToClientId}`
              )
              .then(response => {
                // add new list
                axios
                  .post(
                    `api/pullouttoclients/create-pull-out-to-client-detail/${pullOutToClientId}`,
                    this.pullOutToClient.pullOutToClientDetails
                  )
                  .then(response => {
                    // update main detail only
                    axios
                      .put(
                        `api/pullouttoclients/${pullOutToClientId}`,
                        this.pullOutToClient
                      )
                      .then(response => {
                        appToast.success(response.data)
                      })
                      .catch(error =>
                        appToast.danger(
                          `Something went wrong on updating main detail: ${error}`
                        )
                      )
                      .then(() => {
                        this.buttonSave = appButton.isLoadingSuccess(false)
                        this.getById(pullOutToClientId)
                      })
                  })
                  .catch(error =>
                    appToast.danger(
                      `Something went wrong in adding new list: ${error}`
                    )
                  )
              })
              .catch(error =>
                appToast.danger(
                  `Something went wrong in removing old list: ${error}`
                )
              )
          }
        }
      })
    },
    searchClients() {
      // authService.isLoggedIn() // check login
      if (this.clientName) {
        axios
          .get(`api/searchqueries/clients-by-name/${this.clientName}/true`)
          .then(response => {
            this.clients = response.data
          })
          .catch(error => console.log(error.response))
      }
    },
    addOrEditTopullOutToClientDetails() {
      this.isLoadingTable = true
      // Update
      if (this.addOrEditToTable === 'Update') {
        let index = null
        let isUsingTempId = false
        const idTypeOf = typeof this.pullOutToClientForTable.id // check if it temp id
        if (idTypeOf === 'string') {
          index = _.findIndex(this.pullOutToClient.pullOutToClientDetails, {
            tempId: this.pullOutToClientForTable.id
          })

          isUsingTempId = true
        } else {
          index = _.findIndex(this.pullOutToClient.pullOutToClientDetails, {
            pullOutToClientDetailId: this.pullOutToClientForTable.id
          })
        }

        if (isUsingTempId) {
          this.pullOutToClient.pullOutToClientDetails.splice(index, 1, {
            quantity: this.pullOutToClientForTable.quantity,
            item: this.pullOutToClientForTable.item,
            serialNumber: this.pullOutToClientForTable.serialNumber,
            datePurchase: this.pullOutToClientForTable.datePurchase,
            endOfWarrantyDate: this.pullOutToClientForTable.endOfWarrantyDate,
            problem: this.pullOutToClientForTable.problem,
            remarks: this.pullOutToClientForTable.remarks,
            tempId: this.pullOutToClientForTable.id
          })
        } else {
          this.pullOutToClient.pullOutToClientDetails.splice(index, 1, {
            quantity: this.pullOutToClientForTable.quantity,
            item: this.pullOutToClientForTable.item,
            serialNumber: this.pullOutToClientForTable.serialNumber,
            datePurchase: this.pullOutToClientForTable.datePurchase,
            endOfWarrantyDate: this.pullOutToClientForTable.endOfWarrantyDate,
            problem: this.pullOutToClientForTable.problem,
            remarks: this.pullOutToClientForTable.remarks,
            pullOutToClientDetailsId: this.pullOutToClientForTable.id
          })
        }
      } else {
        // Create
        this.pullOutToClient.pullOutToClientDetails = [
          ...this.pullOutToClient.pullOutToClientDetails,
          {
            quantity: this.pullOutToClientForTable.quantity,
            item: this.pullOutToClientForTable.item,
            serialNumber: this.pullOutToClientForTable.serialNumber,
            datePurchase: this.pullOutToClientForTable.datePurchase,
            endOfWarrantyDate: this.pullOutToClientForTable.endOfWarrantyDate,
            problem: this.pullOutToClientForTable.problem,
            remarks: this.pullOutToClientForTable.remarks,
            tempId: `t${new Date().getTime()}`
          }
        ]
      }

      this.defaultPullOutToClientForTable()
    },
    removeFromTable(id) {
      this.isLoadingTable = true
      this.buttonDelete = appButton.isLoadingDanger(true)
      // check if id is temp or with t
      const idTypeOf = typeof id
      if (idTypeOf === 'string') {
        // check if id is string, if it is string, remove from the array, if not, remove from the database
        const hasT = id.charAt(0)
        if (hasT === 't') {
          _.remove(this.pullOutToClient.pullOutToClientDetails, { tempId: id }) // Create module
        }
      } else {
        // delete if the id is from saved info
        _.remove(this.pullOutToClient.pullOutToClientDetails, {
          pullOutToClientDetailId: id
        })
      }
      this.isLoadingTable = false
      this.buttonDelete = appButton.isLoadingDanger(false)
    },
    selectForEdit(row) {
      this.addOrEditToTable = 'Update'
      this.pullOutToClientForTable.quantity = row.quantity
      this.pullOutToClientForTable.item = row.item
      this.pullOutToClientForTable.serialNumber = row.serialNumber
      this.pullOutToClientForTable.datePurchase = row.datePurchase
      this.pullOutToClientForTable.endOfWarrantyDate = row.endOfWarrantyDate
      this.pullOutToClientForTable.problem = row.problem
      this.pullOutToClientForTable.remarks = row.remarks
      this.pullOutToClientForTable.id = row.id
    },
    cancelSelected() {
      this.defaultPullOutToClientForTable()
    },
    defaultPullOutToClientForTable() {
      this.isLoadingTable = false
      this.pullOutToClientForTable = {}
      this.addOrEditToTable = 'Add'
    }
  },
  watch: {
    selectedClient() {
      if (this.selectedClient.id) {
        this.pullOutToClient.clientId = this.selectedClient.id
        this.pullOutToClient.address = this.selectedClient.description2
      } else {
        this.pullOutToClient.clientId = 0
        this.selectedClient = 0
      }
    }
  }
}
</script>
